import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { getLoyaltyRedesign2025Active } from '../../../store/componentStores/LodgeConfig/lodgeConfig.selectors';
import { getAvailableOffers, getAvailableOffersBySearch } from '../../../store/componentStores/Offer/offer.selectors';
import { showLoyalty } from '../../../store/reducers';
import { Box, Text } from '../../ui-kit';
import theme from '../../ui-kit/themes/theme';
import {
  editCopyByReplaceString,
  editCopyByReplaceWithComponent,
  editCopyByReplaceWithMultipleComponent
} from '../../utilities/copyFunctions';
import { LOYALTY_IMAGES } from '../assets/images';
import { BonusDealsLink, Icon, LoyaltyAvailableContainer } from '../assets/styles';
import * as COPY from '../utilities/copy';

function earnCopySelection(loyaltyEarnThresholdNights = 2, numberOfNights, loyaltyRedesign2025Active, adventureBucks) {
  if (numberOfNights < loyaltyEarnThresholdNights) {
    return editCopyByReplaceString(COPY.EARN_POINTS, loyaltyEarnThresholdNights, '<THRESHOLD_NIGHTS>');
  }
  return loyaltyRedesign2025Active && adventureBucks > 0 ? COPY.SELECT_SUITE : COPY.START_EARNING;
}

function getLoyaltyCopy(availableOffers, loyaltyRedesign2025Active, isMobile) {
  if (loyaltyRedesign2025Active) {
    if (isMobile) return COPY.YOU_HAVE_POINTS_BONUS_LINK_2_MOBILE;
    return availableOffers.length > 0 ? COPY.YOU_HAVE_POINTS_BONUS_LINK_2 : COPY.YOU_HAVE_2;
  }
  return availableOffers.length > 0 ? COPY.YOU_HAVE_POINTS_BONUS_LINK : COPY.YOU_HAVE;
}

function getBonusDealsCopy(getAvailableOffersBySearch, loyaltyRedesign2025Active) {
  if (loyaltyRedesign2025Active) {
    return COPY.BONUS_DEALS;
  }
  return getAvailableOffersBySearch.length === 1 ? COPY.YOU_HAVE_A_BONUS_DEAL : COPY.YOU_HAVE_BONUS_DEALS;
}

function getPointsBoldText(getAvailableOffersBySearch, loyaltyRedesign2025Active) {
  return getAvailableOffersBySearch.length > 0 || loyaltyRedesign2025Active
    ? COPY.VOYAGERS_POINTS_NO_EXCLAMATION
    : COPY.VOYAGERS_POINTS_EXCLAMATION;
}

const LoyaltyPointsAndText = ({ isNewWidgetStyleActive, copy }) => {
  return (
    <Text
      style={{ display: 'block ruby' }}
      fontSize={!isNewWidgetStyleActive ? 1 : 2}
      color={!isNewWidgetStyleActive ? theme.colors.pureWhite[0] : theme.colors.deepLakeBlue[100]}
      lineHeight={!isNewWidgetStyleActive ? 20 : 16}>
      {copy}
    </Text>
  );
};

const LoyaltyAvailable = ({
  isNewWidgetStyleActive,
  adventureBucks,
  iconLink,
  iconSize,
  showLoyalty,
  getAvailableOffersBySearch,
  loyaltyEarnThresholdNights = 2,
  numberOfNights = 0,
  loyaltyRedesign2025Active,
  isInsideBookingWidget = false,
  availableOffers
}) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${theme.breakpoints.sm})`
  });

  const bonusDealColor = (loyaltyRedesign2025Active, isNewWidgetStyleActive) => {
    if (loyaltyRedesign2025Active && isNewWidgetStyleActive) {
      return 'deepForestGreen.100';
    }

    if (loyaltyRedesign2025Active && !isNewWidgetStyleActive) {
      return 'voyagersVoyagersMoss';
    }

    if (isNewWidgetStyleActive) {
      return 'voyagersGreen';
    }
    return 'springGreen.100';
  };

  const bonusDealLink = (
    <BonusDealsLink
      loyaltyRedesign2025Active={loyaltyRedesign2025Active}
      color={bonusDealColor(loyaltyRedesign2025Active, isNewWidgetStyleActive)}
      onClick={() => {
        document.querySelector('[data-eventid="voyagers-club-offers"]').click();
      }}>
      {getBonusDealsCopy(getAvailableOffersBySearch, loyaltyRedesign2025Active)}
    </BonusDealsLink>
  );

  const boldText = (
    <Text as={'b'}>
      {editCopyByReplaceString(
        getPointsBoldText(getAvailableOffersBySearch, loyaltyRedesign2025Active),
        adventureBucks,
        '<POINTS>'
      )}
    </Text>
  );

  const noPointsCopy = {
    '<TEXT>': boldText,
    '<SECOND_TEXT>':
      availableOffers.length > 0
        ? bonusDealLink
        : earnCopySelection(loyaltyEarnThresholdNights, numberOfNights, loyaltyRedesign2025Active, adventureBucks)
  };

  const withPointsCopy = {
    '<TEXT>': boldText,
    '<SECOND_TEXT>': availableOffers.length > 0 ? bonusDealLink : COPY.SELECT_SUITE
  };

  const textForMobileTest = {
    '<TEXT>': boldText,
    '<SECOND_TEXT>': bonusDealLink
  };

  const copyToUse = getLoyaltyCopy(availableOffers, loyaltyRedesign2025Active, isMobile);

  const LoyaltyContainer = (
    <LoyaltyAvailableContainer
      isNewWidgetStyleActive={isNewWidgetStyleActive}
      isMobile={isMobile}
      isInsideBookingWidget={isInsideBookingWidget}
      loyaltyRedesign2025Active={loyaltyRedesign2025Active}>
      <Icon
        alignSelf={isNewWidgetStyleActive || loyaltyRedesign2025Active ? 'flex-start' : 'center'}
        src={
          loyaltyRedesign2025Active
            ? isNewWidgetStyleActive
              ? LOYALTY_IMAGES.VOYAGER_ICON_FOREST_GREEN
              : LOYALTY_IMAGES.ADVENTURE_BUCK_COIN_MOSS
            : iconLink
        }
        alt="Loyalty"
        size={isNewWidgetStyleActive ? (isMobile && !loyaltyRedesign2025Active ? '32px' : '24px') : iconSize}
      />
      <Box ml={isMobile && !isInsideBookingWidget ? 3 : 2}>
        <Text
          as="p"
          my="0"
          fontSize={isMobile ? 1 : 0}
          fontWeight={theme.fontWeights.medium}
          color={!isNewWidgetStyleActive ? theme.colors.pureWhite[0] : theme.colors.deepLakeBlue[100]}>
          {isMobile ? (
            <>
              <Text
                mb={loyaltyRedesign2025Active ? 2 : 0}
                width={loyaltyRedesign2025Active && availableOffers.length > 0 ? '75%' : '100%'}
                fontWeight={theme.fontWeights.bold}
                fontSize={isNewWidgetStyleActive ? 0 : 1}
                color={!isNewWidgetStyleActive ? theme.colors.pureWhite[0] : theme.colors.deepLakeBlue[100]}
                lineHeight={!isNewWidgetStyleActive ? 20 : 16}>
                {availableOffers.length > 0
                  ? editCopyByReplaceWithMultipleComponent(copyToUse, textForMobileTest)
                  : loyaltyRedesign2025Active
                  ? editCopyByReplaceWithComponent(COPY.POINTS_AVAILABLE, boldText, '<POINTS>')
                  : editCopyByReplaceString(COPY.YOU_HAVE_POINTS, adventureBucks, '<POINTS>')}
              </Text>
              {adventureBucks === 0 ? (
                <Text
                  mt={isNewWidgetStyleActive || loyaltyRedesign2025Active ? 0 : 1}
                  fontSize={isNewWidgetStyleActive || loyaltyRedesign2025Active ? 0 : 9}
                  color={!isNewWidgetStyleActive ? theme.colors.pureWhite[0] : theme.colors.deepLakeBlue[100]}
                  fontWeight={
                    isNewWidgetStyleActive || loyaltyRedesign2025Active
                      ? theme.fontWeights.medium
                      : theme.fontWeights.regular
                  }
                  lineHeight={loyaltyRedesign2025Active ? '150%' : !isNewWidgetStyleActive ? 20 : 16}>
                  {earnCopySelection(
                    loyaltyEarnThresholdNights,
                    numberOfNights,
                    loyaltyRedesign2025Active,
                    adventureBucks
                  )}
                </Text>
              ) : (
                <Text
                  mt="1"
                  fontSize={isNewWidgetStyleActive || loyaltyRedesign2025Active ? 0 : 9}
                  color={!isNewWidgetStyleActive ? theme.colors.pureWhite[0] : theme.colors.deepLakeBlue[100]}
                  fontWeight={loyaltyRedesign2025Active ? theme.fontWeights.medium : theme.fontWeights.regular}
                  lineHeight={loyaltyRedesign2025Active ? '150%' : !isNewWidgetStyleActive ? 14 : 16}>
                  {COPY.SELECT_SUITE}
                </Text>
              )}
            </>
          ) : (
            <>
              {adventureBucks === 0 ? (
                <LoyaltyPointsAndText
                  isNewWidgetStyleActive={isNewWidgetStyleActive}
                  copy={editCopyByReplaceWithMultipleComponent(copyToUse, noPointsCopy)}
                />
              ) : (
                <LoyaltyPointsAndText
                  isNewWidgetStyleActive={isNewWidgetStyleActive}
                  copy={editCopyByReplaceWithMultipleComponent(copyToUse, withPointsCopy)}
                />
              )}
            </>
          )}
        </Text>
      </Box>
    </LoyaltyAvailableContainer>
  );

  return <>{showLoyalty ? LoyaltyContainer : null}</>;
};
LoyaltyAvailable.propTypes = {
  adventureBucks: PropTypes.number,
  iconLink: PropTypes.string,
  iconSize: PropTypes.string
};
LoyaltyAvailable.defaultProps = {
  adventureBucks: '153',
  iconLink: LOYALTY_IMAGES.ADVENTURE_BUCK_COIN
};

const mapStateToProps = state => ({
  showLoyalty: showLoyalty(state),
  getAvailableOffersBySearch: getAvailableOffersBySearch(state),
  loyaltyRedesign2025Active: getLoyaltyRedesign2025Active(state.lodgeConfig),
  availableOffers: getAvailableOffers(state)
});

export default connect(mapStateToProps)(LoyaltyAvailable);
